import {min} from 'lodash';

export function suggestionsFilter(currentValue, suggestion) {
    const size = min([currentValue.length, suggestion.length]),
        cur = currentValue.substring(0, size).toLowerCase(),
        sug = suggestion.substring(0, size).toLowerCase();

    return cur == sug;
}
